'use client';

import NextErrorBoundary, { type NextErrorBoundaryProps } from '@/components/common/next-error-boundary';

const ErrorPage = (props: NextErrorBoundaryProps) => (
  <NextErrorBoundary {...props} />
);

export default ErrorPage;
